import '../../config'
import {message} from 'antd'

function getStrValue(params,key) {
    return params[key];
}

function getRequestHeader(header,func,type) {
    let contentType = '';

    if (type === 'POST') {
        contentType = "application/json;charset=utf-8";
    } else  {
        contentType = "application/x-www-form-urlencoded; charset=utf-8"
    }

    if (header === null) {
        header = new Headers({
            'Accept': 'application/json',
            "Content-Type": contentType,
        });
        if (func !== 'token') {
            if (global.constants.loginusertoken != null) {
                header.append('loginusertoken',global.constants.loginusertoken);
            } else {
                if (localStorage.getItem('loginusertoken') != null) {
                    header.append('loginusertoken',localStorage.getItem('loginusertoken'));
                }
            }
            if (global.constants.authentication != null) {
                header.append('authentication','TOKEN ' + global.constants.authentication);
            } else {
                if (localStorage.getItem('authentication') != null) {
                    header.append('authentication','TOKEN ' + localStorage.getItem('authentication'));
                }
            }
        }

    }
    return header;
}

export function fetchPost(func, params, header) {

    let retHeader = getRequestHeader(header,func,'POST');
    const request = fetch(global.constants.domain.concat(func), {
        method: 'POST',
        body: params,
        mode: 'cors',
        // credentials: 'include',
        // cache: "force-cache",
        headers: retHeader,
    })

    return fetchResult(request);
}

export function fetchGet(func, params, header) {
    let url = global.constants.domain.concat(func);
    let retHeader = getRequestHeader(header,func,'GET');
    if (params) {
        let paramsArray = [];
        //拼接参数
        Object.keys(params).forEach(key =>
            paramsArray.push(key + '=' + getStrValue(params, key)));

        if (paramsArray.length > 0) {
            if (url.search(/\?/) === -1) {
                url += '?' + paramsArray.join('&')
            } else {
                url += '&' + paramsArray.join('&')
            }
        }
    }
    const request = fetch(url, {
        method: 'GET',
        mode: 'cors',
        // credentials: 'include',
        // cache: "force-cache",
        headers: retHeader,
    });
    return fetchResult(request);

}

/**
 * 处理网络请求结果
 * @param request
 * @returns {*}
 */
function fetchResult(request) {
    // try {
        return request
            .then(res => res.json())
            .then((response) => {
            // if (response.code === 200) {
                return response;


            // } else {
            //     return response
            // }
        })
    //         .catch(error => {
    //         if (error.json) {
    //             return error.json()
    //         } else {
    //             return Promise.reject('请求异常')
    //         }
    //     })
    // } catch (e) {
    //     return Promise.reject('请求异常')
    // }

}